import { WasteManifestReviewRow } from "generated-graphql/graphql";

import { usePipelineRowClassificationExplanation } from "./api";
import { computePipelineRowDifferences } from "./differences";
import { WasteClassificationExplanationDialog } from "./WasteClassificationDialog";

export interface PipelineRowClassificationDialogProps {
  open: boolean;
  row: Pick<WasteManifestReviewRow, "id" | "classification" | "reportable">;
  onClose: () => void;
  subtitle?: string;
}

export function PipelineRowClassificationDialog({
  row,
  ...frame
}: PipelineRowClassificationDialogProps) {
  const { explanation, loading, error } = usePipelineRowClassificationExplanation(row.id);
  return (
    <WasteClassificationExplanationDialog
      {...frame}
      explanation={explanation}
      loading={loading}
      error={error}
      differences={explanation ? computePipelineRowDifferences(explanation, row) : {}}
    />
  );
}
